// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__u3JXN","actions":"style_actions__7Huy3","actions_btn":"style_actions_btn__lNfLx"};